import React from 'react';
import { cn } from '@/lib/utils';

type ColorSwatchProps = {
  color: string;
  isActive: boolean;
  onClick: () => void;
  title?: string;
  className?: string;
};

export const ColorSwatch: React.FC<ColorSwatchProps> = ({ color, isActive, onClick, title, className }) => (
  <button
    onClick={onClick}
    className={cn(
      "w-6 h-6 rounded border-2 transition-all",
      isActive ? "border-[rgb(var(--accent-1))]" : "border-zinc-600",
      className
    )}
    style={{ backgroundColor: color }}
    title={title}
  />
);